<template>
  <b-card>
    <div class="price-packages-list-provider">
      <span>
        <b>{{ t('Selected Provider') }} </b>
        {{ checkedProvider ? checkedProvider.name : t('Not Selected') }}
      </span>

      <b-button variant="primary" type="button" size="sm" @click="openProviderModal">
        <feather-icon icon="PlusIcon" size="15" />
        <span>{{ checkedProvider ? t('Update Provider Choice') : t('Select Provider') }}</span>
      </b-button>
    </div>
    <b-button
      id="default-filter-new-btn"
      variant="primary"
      type="button"
      size="sm"
      class="mb-2"
      @click="createPricePackage()"
    >
      <feather-icon icon="PlusIcon" size="15" />
      <span>{{ t('Add New Price Packages') }}</span>
      <b-tooltip
        triggers="hover"
        target="default-filter-new-btn"
        :title="t('Add New Price Packages')"
        :delay="{ show: 0, hide: 50 }"
      />
    </b-button>

    <vue-good-table
      mode="remote"
      :sort-options="{ enabled: false }"
      :total-rows="totalRecords"
      :is-loading.sync="isLoading"
      :show-footer="true"
      :pagination-options="{
        enabled: true,
        jumpFirstOrLast: true,
        rowsPerPageLabel: t('Rows per page'),
        ofLabel: t('ofLabel'),
        nextLabel: t('nextLabel'),
        prevLabel: t('prevLabel'),
        dropdownAllowAll: false
      }"
      :rows="rows"
      :columns="getColumns"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'name'">
          {{ props.row.firstname || '-' }}
        </span>
        <span v-else-if="props.column.field === 'type'">
          <b-badge pill :variant="props.row.type === 0 ? 'secondary' : 'primary'">
            {{ props.row.type === 0 ? t('Warehouse') : t('Branch') }}
          </b-badge>
        </span>
        <span v-else-if="props.column.field === 'phone_number'">
          {{ props.row.phone_number || '-' }}
        </span>
        <span v-else-if="props.column.field === 'email'">
          {{ props.row.email || '-' }}
        </span>
        <span v-else-if="props.column.field === 'attention_name'">
          {{ props.row.authorized_name || '-' }}
        </span>
        <span v-else-if="props.column.field === 'isDefault'">
          <b-badge pill class="text-white" :variant="props.row.isDefault ? 'success' : 'danger'">
            {{ props.row.isDefault ? t('Active') : t('Passive') }}
          </b-badge>
        </span>
        <span v-else-if="props.column.field === 'status'">
          <b-badge pill class="text-white" :variant="props.row.status ? 'success' : 'danger'">
            {{ props.row.status ? t('Active') : t('Passive') }}
          </b-badge>
        </span>

        <span v-else-if="props.column.field === 'actions'">
          <span class="d-flex justify-content-center table-icon-buttons">
            <b-button
              :id="`providers-button-${props.row.id}`"
              variant="primary"
              type="button"
              size="sm"
              @click="detailProvider(props.row.id)"
            >
              <feather-icon icon="TruckIcon" size="15" />
              <b-tooltip
                triggers="hover"
                :target="`providers-button-${props.row.id}`"
                :title="t('Provider Region Rates')"
                :delay="{ show: 0, hide: 0 }"
                boundary="viewport"
              />
            </b-button>
            <b-button
              :id="`edit-button-${props.row.id}`"
              variant="primary"
              type="button"
              size="sm"
              @click="detailPricePackages(props.row.id)"
            >
              <feather-icon icon="Edit3Icon" size="15" />
              <b-tooltip
                triggers="hover"
                :target="`edit-button-${props.row.id}`"
                :title="t('Edit Price Package')"
                :delay="{ show: 0, hide: 0 }"
                boundary="viewport"
              />
            </b-button>
            <b-button
              :id="`delete-package-button-${props.row.id}`"
              variant="danger"
              type="button"
              size="sm"
              @click="deletePricePackage(props.row.id)"
            >
              <feather-icon icon="XIcon" size="15" />
              <b-tooltip
                triggers="hover"
                :target="`delete-package-button-${props.row.id}`"
                :title="t('Delete Price Package')"
                :delay="{ show: 0, hide: 0 }"
                boundary="viewport"
              />
            </b-button>
          </span>
        </span>
      </template>
    </vue-good-table>
    <b-modal
      id="providerModal"
      ref="providerModal"
      title="Sağlayıcı Seç"
      size="lg"
      :ok-title="t('Save')"
      :cancel-title="t('Close')"
      cancel-variant="outline-secondary"
      centered
      @ok="handleOk"
    >
      <div class="provider-list">
        <div v-for="provider in allProviders" :key="provider.id" class="provider-item">
          <div class="provider-info">
            <img
              :src="getProviderLogo(provider)"
              :alt="provider.name + ' Logo'"
              class="provider-logo"
            />
            <span class="provider-name">{{ provider.name }}</span>
          </div>
          <b-button
            variant="outline-primary"
            class="b-btn-outline-primary"
            @click="selectProvider(provider)"
          >
            {{ checkedProvider && provider.id === checkedProvider.id ? 'Seçimi Kaldır' : 'Seç' }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </b-card>
</template>
<script>
import { BBadge, BButton, BCard, BTooltip, BModal } from 'bootstrap-vue';
import { VueGoodTable } from 'vue-good-table';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import { mapGetters } from 'vuex';
import useService from '@/auth/service/useService';
import { getProviderLogo } from '@/libs/providerHelper';

export default {
  components: {
    BBadge,
    BButton,
    BCard,
    BTooltip,
    BModal,

    VueGoodTable
  },

  mixins: [helper],

  data() {
    return {
      isLoading: false,
      rows: [],
      totalRecords: 0,
      filter: {
        page: 1,
        limit: 10
      },
      values: {
        status: false
      },
      selectedProvider: null
    };
  },

  computed: {
    ...mapGetters({
      checkedProvider: 'app/checkedProvider',
      allProviders: 'app/allProviders'
    }),
    getColumns() {
      if (!this.rows.length) {
        return [];
      }

      return [
        {
          label: this.$t('Title'),
          field: 'title'
        },
        {
          label: this.$t('Description'),
          field: 'description'
        },
        {
          label: this.$t('Default'),
          field: 'isDefault'
        },
        {
          label: this.$t('Status'),
          field: 'status'
        },
        {
          label: this.$t('Actions'),
          field: 'actions'
        }
      ];
    }
  },

  async created() {
    this.loadItems();
  },

  methods: {
    createPricePackage() {
      this.$router.push('/price_packages/create');
    },
    updatePackageModal(index) {
      this.$refs['update-package-modal'][index].show();
    },

    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps };
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.filter.page = 1;
      this.updateParams({ limit: params.currentPerPage });
      this.loadItems();
    },

    loadItems() {
      let requestData = this.filter;

      requestData = {
        ...requestData
      };

      this.isLoading = true;

      useService
        .getAllPricePackages(requestData)
        .then(response => {
          this.rows = response.data;
          this.totalRecords = response.meta.total;
        })
        .finally(() => {
          this.isLoading = false;
        });

      if (this.allProviders.length < 1) {
        this.getProviderList();
      }

      // if(requestData.dateFrom && requestData.dateTo && (new Date(requestData.dateFrom) > new Date(requestData.dateTo))) {
      //   this.showErrorMessage(this.$t('Big Date Error'), this.$t('Unsuccessful'))
      //   return false
      // }
    },

    deletePricePackage(id) {
      this.$swal({
        title: `${this.$t('Warning')}!`,
        text: `${this.$t('Price Package Delete Warning')}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `${this.$t('Yes')}`,
        cancelButtonText: `${this.$t('No')}`,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then(async result => {
        if (result.value) {
          await this.deletePricePackageRequest(id)
            .then(response => {
              this.showSuccessMessage(
                `${response.message || this.$t('Price Package Was Deleted')}`
              );

              this.filter.page = 1;
              this.loadItems();
            })
            .catch(messages => {
              if (typeof messages === 'object' && messages && messages.length) {
                messages.forEach(item => {
                  this.showErrorMessage(item.message);
                });
              }
            });
        }
      });
    },

    getProviderList() {
      useService.getAllProviders({ page: 1, limit: 1000 }).then(response => {
        this.$store.commit('app/SET_ALL_PROVIDERS', response.data);
      });
    },

    selectProvider(provider) {
      if (this.checkedProvider && this.checkedProvider.id === provider.id) {
        this.$store.commit('app/SET_CHECKED_PROVIDER', null);
        return false;
      }

      this.$store.commit('app/SET_CHECKED_PROVIDER', provider);

      return true;
      // this.$bvModal.hide('providerModal');
    },

    handleOk() {
      this.$bvModal.hide('providerModal');
    },

    detailPricePackages(id) {
      this.$router.push(`/price_packages/${id}`);
    },

    detailProvider(id) {
      if (!this.checkedProvider) {
        this.showErrorMessage(this.$t('Please select a provider'));
        return false;
      }

      const providerId = this.checkedProvider.id;
      this.$router.push(`/price_packages/${id}/provider/${providerId}/region-rates`);

      return true;
    },

    async deletePricePackageRequest(id) {
      return useService.deletePricePackage(id);
    },
    openProviderModal() {
      this.$bvModal.show('providerModal');
    },
    getProviderLogo
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';

.package-card {
  background-color: #4f4f4f80 !important;
  margin: 24px;
}

.checkbox {
  width: 100%;
  margin-left: 5px;
}

.provider-list {
  background-color: transparent;
  padding: 15px;
}

.provider-item {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
}

.provider-info {
  display: flex;
  align-items: center;
}

.provider-logo {
  max-width: 50px;
  max-height: 50px;
  margin-right: 10px;
}

.provider-name {
  flex: 1;
  margin-left: 50px;
  font-weight: bold;
  font-size: 14px;
}

.provider-item .b-btn-outline-primary {
  border-color: #007bff;
  width: 150px;
}
</style>
